// extracted by mini-css-extract-plugin
export default {"figure":"standout-quote_figure__SztIZ","quote":"standout-quote_quote__iYt+P","caption":"standout-quote_caption__DMAu8"};